var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDah({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 101.07 80.53",
    style: {
      enableBackground: "new 0 0 101.07 80.53"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#603813;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "12.64,13.42 12.64,13.42 12.64,13.42  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.66,1.42c-0.9-0.5-2.15-0.77-3.74-0.76l-4.34,0.02l0.05,12.73l4.56-0.02c3.97-0.02,6.44-2.19,6.43-6.39 C23.61,4.4,22.47,2.45,20.66,1.42z M17.34,10.54L17.34,10.54l-1.46,0.01l-0.03-7.02l1.48-0.01c1.88-0.01,3.03,1.24,3.04,3.51 C20.38,9.36,19.22,10.53,17.34,10.54z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.62,8.66c-0.01-2.96-2.21-5.21-5.06-5.19c-2.81,0.01-5,2.4-4.99,5.15c0.01,2.84,2.33,5.05,5.08,5.04 c2.01-0.01,3.75-1.24,4.65-3.32l-2.93,0.01c-0.46,0.6-0.96,0.9-1.73,0.9c-1.17,0-2.08-0.71-2.25-1.8l7.16-0.03 C35.6,9.16,35.62,8.93,35.62,8.66z M28.42,7.52c0.22-1.02,1.11-1.64,2.14-1.64c1.1,0,1.97,0.65,2.19,1.63L28.42,7.52z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.89,
    y: 0.57,
    transform: "matrix(1 -4.217129e-03 4.217129e-03 1 -0.0289 0.1659)",
    className: "st0",
    width: 2.86,
    height: 12.73
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "43.52,2.72 43.51,0.55 46.37,0.54 46.38,2.71 43.52,2.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "43.56,13.29 43.52,3.74 46.38,3.73 46.42,13.28 43.56,13.29  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.9,7.37c-0.42-0.89-1.16-1.34-2.14-1.33c-1.31,0.01-2.2,1.09-2.19,2.44c0.01,1.39,0.96,2.42,2.28,2.42 c0.96,0,1.63-0.45,2.06-1.28l2.91-0.01c-0.56,2.39-2.6,3.95-5.04,3.96c-2.82,0.01-5.07-2.27-5.08-5.09 c-0.01-2.86,2.23-5.09,4.99-5.1c2.51-0.01,4.57,1.56,5.11,3.99L55.9,7.37L55.9,7.37z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.03,
    y: 0.48,
    transform: "matrix(1 -3.981696e-03 3.981696e-03 1 -5.713428e-03 0.2487)",
    className: "st0",
    width: 2.86,
    height: 2.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.06,
    y: 3.66,
    transform: "matrix(1 -4.116881e-03 4.116881e-03 1 -0.0342 0.2573)",
    className: "st0",
    width: 2.86,
    height: 9.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.34,3.31c-2.86,0.01-5.14,2.14-5.12,5.1c0.01,2.93,2.26,5.07,5.17,5.05c2.87-0.01,5.14-2.14,5.12-5.13 C76.5,5.44,74.22,3.3,71.34,3.31z M71.37,10.8c-1.29,0.01-2.29-1.09-2.3-2.4c-0.01-1.31,1-2.41,2.26-2.42 c1.34-0.01,2.31,1.13,2.32,2.4C73.66,9.65,72.71,10.79,71.37,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.93,13.12l0-1.02h-0.03c-0.41,0.88-1.16,1.33-2.46,1.34c-2.01,0.01-3.69-1.19-3.7-3.91l-0.02-5.94 l2.86-0.01l0.02,5.35c0,1.26,0.46,1.84,1.54,1.84c1.08,0,1.63-0.73,1.63-1.9l-0.02-5.3l2.86-0.01l0.04,9.55L84.93,13.12 L84.93,13.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.57,6.21c-0.02-0.55-0.42-0.72-0.88-0.72c-0.48,0-0.82,0.28-0.82,0.64c0,0.52,0.47,0.77,1.79,1.11 c2.27,0.59,3.02,1.5,3.02,2.9c0.01,2-1.71,3.26-3.88,3.27c-2.15,0.01-3.69-1.21-3.9-3.15l2.84-0.01c0.09,0.6,0.52,0.88,1.09,0.87 c0.5,0,1-0.3,1-0.74c0-0.53-0.33-0.81-1.76-1.25c-2.41-0.73-3.05-1.67-3.06-2.79C90,4.44,91.77,3.21,93.7,3.2 c2.06-0.01,3.53,1.12,3.68,3L94.57,6.21L94.57,6.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.16,24.75l-0.26,0.98l-0.03-0.01c-0.31-0.99-1.24-1.72-2.36-2.02c-2.64-0.7-5.21,0.96-5.93,3.69 c-0.74,2.79,0.58,5.44,3.31,6.17c1.21,0.32,2.44,0.12,3.06-0.59l0.03,0.01l-0.27,1l2.76,0.74l2.46-9.23L17.16,24.75z M15.93,29.36 L15.93,29.36c-0.35,1.33-1.64,2.09-2.94,1.75c-1.28-0.34-2.01-1.66-1.67-2.94c0.35-1.33,1.63-2.11,2.9-1.78c0,0,0,0,0,0 C15.51,26.74,16.28,28.06,15.93,29.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.97,36.99l1.36-5.12c0.33-1.25,0.06-1.94-0.96-2.21c-1.11-0.3-1.74,0.19-2.08,1.44l-1.36,5.09l-2.76-0.74 l2.46-9.23l2.58,0.69l-0.26,0.98l0.03,0.01c0.83-0.79,1.74-0.93,2.86-0.63c1.66,0.44,3.18,1.84,2.45,4.57l-1.57,5.89L25.97,36.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.51,27.94l-1.03,3.86c-0.57-0.99-1.35-1.54-2.42-1.82c-2.69-0.72-5.14,0.93-5.88,3.69 c-0.75,2.79,0.51,5.43,3.31,6.17c1.31,0.35,2.36,0.15,3.11-0.56l0.03,0.01l-0.27,1l0,0l2.63,0.7l3.28-12.31L41.51,27.94z  M39.62,35.63c-0.36,1.36-1.65,2.11-2.99,1.75c-1.33-0.35-2.05-1.6-1.68-2.99c0.36-1.35,1.65-2.04,2.94-1.69 C39.25,33.06,39.96,34.35,39.62,35.63z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "6.73,54.42 8.84,49.78 5.04,48.06 2.94,52.7 -0.02,51.36 5.24,39.76 8.2,41.1 6.22,45.46 10.02,47.18  11.99,42.82 14.95,44.17 9.69,55.76 6.73,54.42  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.85,51.25l-0.42,0.92l-0.03-0.01c-0.14-1.03-0.94-1.9-2-2.38c-2.49-1.13-5.29,0.09-6.46,2.66 c-1.19,2.63-0.32,5.47,2.25,6.63c1.14,0.52,2.39,0.52,3.12-0.08L19.34,59l-0.43,0.94l2.6,1.18l3.94-8.7L22.85,51.25z M20.89,55.59 c-0.57,1.25-1.97,1.79-3.19,1.24c-1.21-0.55-1.72-1.97-1.17-3.18c0.57-1.25,1.96-1.81,3.15-1.27c0,0,0,0,0,0 C20.9,52.93,21.44,54.37,20.89,55.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.38,55.66c-1.08-0.49-2.21-0.53-3.3,0.02l-0.05-0.02l0.43-0.96l-2.45-1.11l-5.26,11.6l0,0l2.6,1.18 l1.67-3.68c0.36,1.09,1.11,1.81,2.13,2.27c2.49,1.13,5.18-0.16,6.3-2.64C36.69,59.6,35.86,56.78,33.38,55.66z M32.9,61.05 c-0.55,1.21-1.94,1.78-3.18,1.22c-1.24-0.56-1.73-1.97-1.18-3.2c0.57-1.25,1.98-1.78,3.17-1.24C32.97,58.4,33.45,59.83,32.9,61.05z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.96,60.91c-1.08-0.49-2.21-0.53-3.3,0.02l-0.05-0.02l0.43-0.96l-2.44-1.11l-5.26,11.6h0l2.6,1.18l1.67-3.68 c0.36,1.09,1.11,1.81,2.13,2.27c2.49,1.13,5.18-0.16,6.3-2.64C48.27,64.85,47.44,62.03,44.96,60.91z M44.48,66.3 c-0.55,1.21-1.94,1.78-3.18,1.22c-1.24-0.56-1.73-1.98-1.18-3.2c0.57-1.25,1.98-1.78,3.17-1.24C44.55,63.65,45.03,65.08,44.48,66.3 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "46.46,75.93 49.36,73.22 49.87,63.5 52.65,64.76 52.1,70.59 52.13,70.61 56.08,66.31 58.84,67.56  49.22,77.18 46.46,75.93  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDah);
export default __webpack_public_path__ + "static/media/dah.6117845f427f683d27ad1f39de05fcb9.svg";
export { ForwardRef as ReactComponent };